import { COUNTRY_CODES } from 'constants/address/counties.const';
import { COUNTRY_CURRENCY } from 'constants/currency.const';
import { KPI_UNIT } from 'constants/staff/kpiUnit.const';
import logger from 'utils/logger.util';

const L = logger('fromMetricTypeToKpiUnit');

export const fromMetricTypeToKpiUnit = (metricType, countryCode) => {
  if (!metricType || typeof metricType !== 'string') {
    L.warn('()', 'Invalid metricType:', metricType);
    return undefined;
  }

  if (metricType === KPI_UNIT.currency) {
    if (!countryCode || typeof countryCode !== 'string') {
      L.warn('()', 'Invalid countryCode:', countryCode);
      return COUNTRY_CURRENCY[COUNTRY_CODES.GB];
    }

    if (!(countryCode in COUNTRY_CURRENCY)) {
      L.warn('()', 'CountryCode not found in COUNTRY_CURRENCY:', countryCode);
      return COUNTRY_CURRENCY[COUNTRY_CODES.GB];
    }

    return COUNTRY_CURRENCY[countryCode];
  }

  return metricType;
};
